<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat>
          <v-toolbar-title>Suppliers Balances</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/suppliers">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
          <v-row>
            <v-col
              cols="12"
              md="4"
              class="subtitle-2 text--primary"
            >Supplier Name: {{ dataItem.Name }}</v-col>
          </v-row>
          <v-divider></v-divider>
  
          <v-row>
            <v-col cols="12">
              <v-data-table
                :items-per-page="20"
                :headers="headers"
                :items="balances"
                :mobile-breakpoint="0"
              >
                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-show="item.Balance == 0"
                    color="primary"
                    text
                    @click="showBalanceModal(item)"
                  >
                    <v-icon left>mdi-plus</v-icon>Opening Balance
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>
          <!-- end -->
        </v-card-text>
      </v-card>
  
      <!-- Balance dialog -->
      <v-dialog v-model="balanceDialog" max-width="650">
        <v-card>
          <v-toolbar dense color="accent" dark>
            <v-toolbar-title>Opening Balance Update</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="balanceDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid class="subtitle-2 text--primary">
              <v-row>
                <v-col cols="12">Shop: {{ selectedItem.storeName }}</v-col>
  
                <v-col cols="5" xs="5" md="6">
                  <v-text-field
                    autocomplete="off"
                    type="number"
                    v-model="amount"
                    label="Opening Balance"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
  
                <v-col cols="6">
                  <DatePicker @date="setDate" :myDate="DocDate" :title="`Date`" ref="dateRef"></DatePicker>
                </v-col>
  
                <v-col cols="12">
                  <v-btn color="primary" @click="save" :loading="loader">
                    <v-icon left>mdi-content-save</v-icon>Update Balance
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of balance modal-->
  
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
    
    <script>
  import { mapGetters } from "vuex";
  export default {
    components: {},
    computed: {
      ...mapGetters(["user"])
    },
    data: () => ({
      dataItem: {},
      loader: false,
      balanceDialog: false,
      amount: 0,
      selectedItem: {},
      balances: [],
      DocDate: null,
      docCreate: false,
      headers: [
        { text: "Store", value: "storeName" },
        { text: "Opening Balance", value: "Balance" },
        { text: "Action", value: "action" }
      ]
    }),
    watch: {
      "$route.params.id": {
        handler: "getBalances",
        immediate: true
      }
    },
    methods: {
      showBalanceModal(item) {
        this.selectedItem = item;
        this.balanceDialog = true;
      },
      setDate(date) {
        this.DocDate = date;
      },
      getBalances(id) {
        const self = this;
        this.$store
          .dispatch("get", `/suppliers/store/balances/${id}`)
          .then(res => {
            console.log(res);
            if (res.ResultCode == 1200) {
              self.dataItem = res.ResponseData["supplier"];
              self.balances = res.ResponseData["balances"];
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      save() {
       const url = `/update-supplier-store-balance`;
  
        if (this.DocDate == null || this.DocDate == undefined) {
          this.$refs.snackbar.show("Please select Date!", "red");
          return;
        }
  
        var data = {
          CardCode: this.selectedItem.CardCode,
          store_id: this.selectedItem.store_id,
          amount: this.amount,
          DocDate: this.DocDate,
          ObjType: 19
        };
        
        const self = this;
        this.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$store.commit("btnLoader", false);
              location.reload();
            } else {
              self.$store.commit("btnLoader", false);
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(err, "red");
          });
      }
    }
  };
  </script>